/* eslint-disable import/prefer-default-export */
export const locationQueryKeys = {
  packingListConfig: (id: string) => ["location", "packing-list", id],
  costRecoverySetting: (id: string, params: any) => ["cost-recover-setting", id, params],
  freightModesConfig: (location: string) => ["location", "freight-modes-config", location],
  getServiceDetailsConfig: (location: string) => ["location", "service-details-config", location],
  paymentLocationFormDetailsConfig: (location: string, params: any) => [
    "location",
    "payment-location-form-details",
    location,
    params,
  ],
  scheduleOptions: (location: string) => ["location", "schedule-options", location],
};
